var ErrorCodes = {
  InvalidSession: -7002,
  SessionNoLongerExists: -1101,
  ChangeUserPassword: -1217,
};

export default ErrorCodes;
